import React, { FC } from 'react';
import styled from 'src/theme';
import {Col, Row} from "antd";
import { Select, Option } from "src/components/UI";

import { usePresenter } from './usePresenter';

export const PailingParameters: FC = () => {

  const presenter = usePresenter();

  return (
    <RowStyled>
      <ColumnLabelStyled xs={24}>
        <LabelTextStyled>Тип покрытия</LabelTextStyled>
      </ColumnLabelStyled>
      <Col xs={24}>
        <Select
          value={presenter.pailingCoating}
          onChange={presenter.pailingCoatingHandler}
          style={{ width: '100%' }}
        >
          <Option value="Полиэстер 0,4 мм">Полиэстер 0,4 мм</Option>
          <Option value="Полиэстер 0,45 мм">Полиэстер 0,45 мм</Option>
          <Option value="Norman MP 0,5 мм">Norman MP 0,5 мм</Option>
          <Option value="Цинк 0,4 мм">Цинк 0,4 мм</Option>
          <Option value="Цинк 0,45 мм">Цинк 0,45 мм</Option>
        </Select>
      </Col>
      <ColumnLabelStyled xs={24}>
        <LabelTextStyled>Вид профнастила</LabelTextStyled>
      </ColumnLabelStyled>
      <Col xs={24}>
        <Select
          value={presenter.pailingType}
          onChange={presenter.pailingTypeHandler}
          style={{ width: '100%' }}
        >
          <Option value="С08">С08</Option>
        </Select>
      </Col>
      <ColumnLabelStyled xs={24}>
        <LabelTextStyled>П-образная планка</LabelTextStyled>
      </ColumnLabelStyled>
      <Col xs={24}>
        <Select
          value={presenter.pailingPBar}
          onChange={presenter.pailingPBarHandler}
          style={{ width: '100%' }}
        >
          <Option value="Нужна">Нужна</Option>
          <Option value="Не нужна">Не нужна</Option>
        </Select>
      </Col>
    </RowStyled>
  );
};

const RowStyled = styled(Row)`
  display: flex;
  padding: 0px 16px 16px;
  flex-direction: column;
  width: 240px;
  row-gap: 0px;
  position: relative;
  margin: 0;
  text-align: left;
  list-style-type: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 2px;
  outline: none;
  box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%);
`;

const ColumnLabelStyled = styled(Col)`
  display: flex;
  min-height: 32px;
  align-items: center;
`;

const LabelTextStyled = styled.span`
  margin-top: 8px;
  width: 100%;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.01em;
  color: #000000;
`;
